import styles from './Grouped.module.scss';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import { flexRender, Row } from '@tanstack/react-table';
import React from 'react';

import { Body2 } from '../../../../../../typography/body2/Body2';
import { Caption } from '../../../../../../typography/caption/Caption';
import { GroupedItem } from '../../../../hooks/query-table-data/types';
import { RowIndent } from '../../../row-indent/RowIndent';
import { TableRow as TableRowComponent } from '../../../table-row/TableRow';

export const GROUP_ROW_MARKER = 'table-row-group-marker';

interface Props {
  row: Row<unknown>;
  cellClassName?: string;
}

export const GroupedV8: React.FC<Props> = (props) => {
  const { row } = props;

  const columnId = row.groupingColumnId;

  const cell = row
    .getAllCells()
    .find((cell) => cell.column.id === row.groupingColumnId);

  if (!cell) {
    console.error('cell not found', columnId);
    return null;
  }

  const groupedInfo = (row.original as GroupedItem).meta;

  const { groupByTotalCount, groupByLabel, groupByVal } = groupedInfo ?? {};

  const attr = { [`data-${GROUP_ROW_MARKER}`]: true };

  const customCell = flexRender(cell.column.columnDef.cell, {
    ...cell.getContext(),
  });

  const defaultCell = flexRender(cell.column.columnDef.groupLabelElement, {
    ...cell.getContext(),
    value: groupByVal,
    label: groupByLabel,
    ...(cell.column.columnDef.groupLabelElementParams ?? {}),
  });

  // This is simplest solution now to just add list which display custom cells
  const displayCustomCell = DISPLAY_CUSTOM_CELL_TYPES.includes(
    //@ts-expect-error props is not recognized by typescript
    customCell.props.column.columnDef.dataType
  );

  return (
    <TableRowComponent isSelected={row.getIsSelected()} isGrouped {...attr}>
      <div className={styles.groupedRowContainer}>
        <RowIndent depth={row.depth} />

        <IconButton size="small" onClick={row.getToggleExpandedHandler()}>
          {row.getIsExpanded() ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </IconButton>

        <Body2 className={styles.title}>
          <div className={styles.header}>
            {cell.column.columnDef.header as string}:
          </div>
          {displayCustomCell ? customCell : defaultCell}
          <Caption className={styles.count}>({groupByTotalCount})</Caption>
        </Body2>
      </div>
    </TableRowComponent>
  );
};

const DISPLAY_CUSTOM_CELL_TYPES = ['ProjectBilling'];
